import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaExternalLinkAlt } from "react-icons/fa";
import { SITE } from "../../constants/site";

const OFFICES = [
  {
    id: "egypt",
    labelKey: "Egypt Office",
    embed: SITE.mapEmbeds.egypt,
    link: SITE.maps.egypt,
    locationKey: "Nasr City, Egypt",
  },
  {
    id: "uae",
    labelKey: "UAE Office",
    embed: SITE.mapEmbeds.uae,
    link: SITE.maps.uae,
    locationKey: "United Arab Emirates",
  },
];

function ContactMap() {
  const { t } = useTranslation();
  const [activeOffice, setActiveOffice] = useState("egypt");
  const office = OFFICES.find(({ id }) => id === activeOffice) || OFFICES[0];

  return (
    <div className="contact-map">
      <div className="contact-map__head">
        <h2 className="contact-map__title">{t("contact.findUs")}</h2>
        <div className="contact-map__tabs" role="tablist" aria-label={t("contact.findUs")}>
          {OFFICES.map(({ id, labelKey }) => (
            <button
              key={id}
              type="button"
              role="tab"
              aria-selected={activeOffice === id}
              className={`contact-map__tab${activeOffice === id ? " is-active" : ""}`}
              onClick={() => setActiveOffice(id)}
            >
              {t(labelKey)}
            </button>
          ))}
        </div>
      </div>

      <div className="contact-map__frame" role="tabpanel">
        <iframe
          key={office.id}
          className="contact-map__iframe"
          title={t(office.locationKey)}
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          src={office.embed}
        />
      </div>

      <a
        href={office.link}
        target="_blank"
        rel="noopener noreferrer"
        className="contact-map__link"
      >
        <span>{t(office.locationKey)}</span>
        <FaExternalLinkAlt aria-hidden="true" />
      </a>
    </div>
  );
}

export default ContactMap;
